module.exports = __webpack_public_path__ + "static/media/washington-dc-2.e5d9f1cd.jpg";